import { useState, useEffect } from "react";
import CloseIcon from "../assets/crossIcon.svg";
import { updateUser } from "../services/AdminServices";
import Select from "react-select";
import { Switch } from "@mui/material";
import { NotificationServices } from "../services/NotificationServices";
import { InterUserMangementServices } from "../services/InternalUserMangementServices";
import { CircularProgress } from "@mui/material";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
const UpdateUserDetails = ({ userDetails, getUserData, isOpen }) => {
  const [roleList, setRoleList] = useState([]);
  const [mappingRole, setMappingRole] = useState(false);
  const [selectedResponsibilities, setSelectedResponsibilities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [permission, setPermission] = useState(userDetails?.permissions);
  const [caseTypePermission, setCaseTypePermission] = useState(
    userDetails?.caseTypePermission,
  );
  const [mapRole, setMapRole] = useState(false);
  const [showUserRoles, setShowUserRoles] = useState([]);
  const [email, setEmail] = useState(userDetails?.email);
  const [fullName, setFullName] = useState(userDetails?.fullName);
  const [userName, setUserName] = useState(userDetails?.userName);
  const [phone, setPhone] = useState(userDetails?.phone);
  const [statusReponsibilityList, setStatusResponsibilityList] = useState([]);
  const getRoleList = async () => {
    try {
      const response = await NotificationServices.getRoleList();

      let userRoles = [];
      for (let tempRole of response?.data?.allRoles) {
        let checkFlag = true;
        for (let role of userDetails?.userrolemappings) {
          if (role.roleId === Number(tempRole.id)) {
            checkFlag = false;
          }
        }
        if (checkFlag) {
          userRoles.push(tempRole);
        }
      }
      setRoleList(userRoles);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getResponsibilityList = async () => {
    try {
      const response =
        await InterUserMangementServices.getUserResponsibilityList(100, 1);
      setStatusResponsibilityList(response?.data?.responsibilities);
      let filteredSelectedResponsibilities = [];
      for (let userResponsibility of userDetails.userresponsibilitymasters) {
        for (let responsibility of response?.data?.responsibilities) {
          if (responsibility.id === userResponsibility.stageStatusId) {
            filteredSelectedResponsibilities.push(responsibility);
          }
        }
      }

      setSelectedResponsibilities(filteredSelectedResponsibilities);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleUpdateMapUser = async () => {
    const data = selectedResponsibilities?.map((responsibility) => ({
      stageStatusId: responsibility.id,
    }));
    try {
      const response = InterUserMangementServices.mapUserResponsibilities({
        userId: userDetails.id,
        responsibilities: data,
      });
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleMapRole = async () => {
    setMappingRole(true);
    try {
      const data = showUserRoles?.map((role) => {
        return {
          userId: userDetails.id,
          roleId: role.id,
        };
      });
      const res = await InterUserMangementServices.manageUserRole(data);
      await getUserData();
      setMapRole(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setMappingRole(false);
  };
  const handleDeactivateUser = async (role) => {
    const data = [
      {
        userId: userDetails.id,
        id: role.id,
        roleId: role.roleId,
        isDeleted: true,
        isActive: true,
      },
    ];
    try {
      const res = await InterUserMangementServices.manageUserRole(data);
      await getUserData();
      setMapRole(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleUserRole = async () => {
    try {
      const data = [];
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleSubmit = async () => {
    setLoading(true);
    const caseTypePermissionData = caseTypePermission?.map(
      (item) => item.value,
    );
    const data = {
      userid: userDetails.id,
      fullName,
      email,
      phone,
      permissions: permission,
      userName,
      caseTypePermissions: {
        permissions: caseTypePermissionData,
      },
    };

    try {
      const response = await updateUser(data);
      handleUpdateMapUser();
      window.alert(response?.data?.message);
      getUserData();
      isOpen(-1);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getRoleList();
    getResponsibilityList();
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [userDetails]);

  return (
    <div className="fixed w-screen h-screen top-0 left-0 flex justify-center items-center bg-[#017C5780] z-[1201]">
      <div className="relative w-[50%]  h-[80%]  bg-white  rounded-[16px] px-4 py-8">
        <div className="absolute right-4 top-4 flex items-center gap-2 ">
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-sm text-[#017C57] px-8 py-2 rounded-full cursor-pointer"
            onClick={() => setMapRole(true)}
          >
            Map Role
          </div>
          <img
            src={CloseIcon}
            alt="close-icon"
            className="cursor-pointer"
            onClick={() => isOpen(-1)}
          />
        </div>
        <div className="text-2xl text-[#191919] font-bold">User Detail</div>
        <div className="h-[80%] flex justify-between items-center flex-wrap space-y-5  mt-4 px-4 overflow-y-scroll">
          <div className="w-[48%]">
            <div>Fullname</div>
            <input
              type="text"
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter User Name"
              onChange={(e) => setFullName(e.target.value)}
              defaultValue={fullName}
            />
          </div>
          <div className="w-[48%]">
            <div>Email</div>
            <input
              type="text"
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter Email"
              onChange={(e) => setEmail(e.target.value)}
              defaultValue={email}
            />
          </div>
          <div className="w-[48%]">
            <div>Phone Number</div>
            <input
              type="text"
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter Phone Number"
              onChange={(e) => setPhone(e.target.value)}
              defaultValue={phone}
            />
          </div>{" "}
          <div className="w-[48%]">
            <div>Alias Name</div>
            <input
              type="text"
              style={{ border: "1px solid #E4E4E4" }}
              className="w-full outline-none p-2 rounded-[8px] mt-2"
              placeholder="Enter Alias Name"
              onChange={(e) => setUserName(e.target.value)}
              defaultValue={userName}
            />
          </div>
          <div className="w-[48%] space-y-2">
            <div>Permission</div>
            <Select
              options={[
                { value: "ALL", label: "ALL" },
                { value: "SALES", label: "SALES" },
                { value: "CASES", label: "CASES" },
              ]}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              onChange={(item) => setPermission(item?.value)}
              value={
                [
                  { value: "ALL", label: "ALL" },
                  { value: "SALES", label: "SALES" },
                  { value: "CASES", label: "CASES" },
                ].find((option) => option.value === permission) || null
              }
            />
          </div>
          <div className="w-[48%] space-y-2">
            <div>Case Type Permission</div>
            <Select
              isMulti
              options={[
                { value: "SURGICAL", label: "SURGICAL" },
                { value: "CONSERVATIVE", label: "CONSERVATIVE" },
                { value: "DAYCARE", label: "DAYCARE" },
              ]}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              onChange={(items) => setCaseTypePermission(items)}
              value={caseTypePermission || []}
            />
          </div>
          <div
            style={{ border: "1px solid #E5E5E5" }}
            className="w-full py-1 px-5 rounded-[8px]"
          >
            <div className="font-semibold mb-2">Roles</div>
            {userDetails?.userrolemappings?.map((role, idx) => {
              return (
                <div
                  key={idx}
                  className={`flex justify-between items-center px-2 py-1 rounded-[4px] ${
                    idx % 2 === 0 ? "bg-[#F5F5F5]" : "bg-white"
                  }
                }`}
                >
                  <div>{role.role.roleName}</div>

                  <Switch
                    checked={!role.isDeleted}
                    onChange={() => {
                      if (window.confirm("Do you want to Inactive Role")) {
                        handleDeactivateUser(role);
                      }
                    }}
                    inputProps={{ "aria-label": "toggle status" }}
                    style={{ color: "#017C57" }}
                  />
                </div>
              );
            })}
          </div>
          <div className="w-full">
            <div className="mb-2">Status Responsibility</div>

            <Select
              options={[
                { commandCenterStageStatus: "Select All" },
                ...statusReponsibilityList,
              ]}
              getOptionLabel={(option) => option.commandCenterStageStatus}
              getOptionValue={(option) => option.commandCenterStageStatus}
              // onChange={(items) => setSelectedResponsibilities(items)}
              onChange={(selected) => {
                const isSelectAllSelected = selected?.some(
                  (opt) => opt.commandCenterStageStatus === "Select All",
                );

                if (isSelectAllSelected) {
                  setSelectedResponsibilities(statusReponsibilityList);
                } else {
                  setSelectedResponsibilities(selected || []);
                }
              }}
              value={selectedResponsibilities}
              isMulti
            />
          </div>
        </div>
        <div className="flex justify-center items-center mt-8">
          {loading ? (
            <CircularProgress />
          ) : (
            <div
              className="text-white bg-[#017C57] px-8 py-2 rounded-full cursor-pointer"
              onClick={handleSubmit}
            >
              Submit
            </div>
          )}
        </div>
      </div>

      {mapRole && (
        <div className="fixed w-screen h-screen top-0 left-0 flex justify-center items-center bg-[#017C5780] z-[1201]">
          <div className="relative w-[50%]  h-[50%]  bg-white  rounded-[16px] px-4 py-8">
            <div className="absolute right-4 top-4 flex items-center gap-2 ">
              <img
                src={CloseIcon}
                alt="close-icon"
                className="cursor-pointer"
                onClick={() => setMapRole(false)}
              />
            </div>

            <div className="w-full space-y-4 mt-5">
              <div>Map Role</div>
              <Select
                options={roleList}
                isMulti
                getOptionLabel={(option) => option.roleName}
                getOptionValue={(option) => option.roleName}
                onChange={(item) => setShowUserRoles(item)}
                value={showUserRoles}
              />
            </div>
            <div className="flex items-center justify-center">
              {mappingRole ? (
                <CircularProgress />
              ) : (
                <div
                  className="text-white bg-[#017C57] px-8 py-2 rounded-full cursor-pointer mt-10"
                  onClick={handleMapRole}
                >
                  SAVE DATA
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateUserDetails;
